<template>
    <section>
        <div class="section-head">
            <div class="sh-inner">
                <h2>RS Melinda 2</h2>
                <h1>Video</h1>
                <p>Halaman yang memberikan kemudahan akses untuk mendapatkan video mengenai kesehatan, gaya hidup, dan informasi menarik lainnya dan tentunya informasi terbaru mengenai RS Melinda 2.</p>
            </div>
            <div class="si-box">
                <div class="si-search" v-if="categories">
                    <div class="si-search-select">
                        <div class="sss-button" id="sss-button-videos" @click="topSearchSelect('sss-button-videos');">
                            <div class="button-cover float-button"></div>
                            <div class="sss-text">
                                <div class="sss-text-title">Kategori</div>
                                <div class="sss-text-button">{{ searchBar.select.title }}</div>
                            </div>
                            <div class="sss-icon">
                                <div class="sss-icon-inner float-arrow">
                                    <img src="../../assets/images/icons/arrow-1.png" alt="rsia melinda"/>
                                </div>
                            </div>
                        </div>
                        <div class="sss-option float">
                            <div class="sss-option-button" @click="usePictureStore().searchbarSelect('Semua', 'all');">
                                <span>Semua</span>
                            </div>
                            <div class="sss-option-button" @click="usePictureStore().searchbarSelect(category.name, category.slug);" v-for="category in categories" :key="category">
                                <span>{{ category.name }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="si-search-input">
                        <input type="text" id="sss-input-articles" :value="searchBar.input.value" placeholder="masukkan kata kunci" autocomplete="off" @input="searchbarInput('sss-input-articles');" />
                    </div>
                    <div class="si-search-button">
                        <span>Cari Video</span>
                    </div>
                </div>
                <ArticlesSearchbarSkeleton v-else/>
            </div>
        </div>
        <div class="section-body" v-if="videosShow">
            <div class="sb-inner">
                <div class="sb-part" v-for="video in videosShow" :key="video">
                    <router-link :to="'/video/detail/' + video.slug">
                        <div class="sb-part-inner">
                            <div class="spi-image">
                                <img :src="video.thumbnail" alt="rsia melinda"/>
                            </div>
                            <div class="spi-text">
                                <!-- <div class="spi-category">
                                    <span>{{ video.category?.name }}</span>
                                </div> -->
                                <div class="spi-title">
                                    <h2>{{ video.name }}</h2>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="section-more" v-if="videosShow.length < videos.length">
                <button @click="usePictureStore().moreVideos();">Load More</button>
            </div>
        </div>
        <ArticlesBodySkeleton v-else/>
    </section>
</template>

<script setup>
    import ArticlesSearchbarSkeleton from '@/components/skeletons/parts/ArticlesSearchbarSkeleton.vue';
    import ArticlesBodySkeleton from '@/components/skeletons/parts/ArticlesBodySkeleton.vue';
    import { computed } from '@vue/reactivity';
    import { usePictureStore } from '@/stores/picture';
    import { topSearchSelect } from '@/functions/general';
    import { searchbarInput } from '@/functions/picture';
    const searchBar = computed(() => usePictureStore().searchBar);
    const videos = computed(() => usePictureStore().videos);
    const videosShow = computed(() => usePictureStore().videosShow);
    const categories = computed(() => usePictureStore().categories);
    usePictureStore().setVideos();
</script>

<style scoped>
    section{
        padding: 0 0 2.5rem 0;
    }
    .section-head{
        position: relative;
        width: 100%;
        padding: 2.5rem 10% 150px 10%;
        background: var(--navy);
    }
    .sh-inner{
        text-align: center;
    }
    .sh-inner h2{
        font-size: 1.1rem;
        color: var(--primary);
        margin: 0;
    }
    .sh-inner h1{
        font-size: 2rem;
        color: var(--white);
        margin: 1rem 0 1rem 0;
    }
    .sh-inner p{
        margin: 0;
        color: var(--white);
    }
    .si-box{
        position: absolute;
        left: 10%;
        right: 10%;
        bottom: -25px;
        transition: 0.2s;
    }
    .si-search{
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: 75px;
        transition: 0.2s;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.37), 0 6px 20px 0 rgba(0, 0, 0, 0.37);
    }
    .si-search-select{
        position: relative;
        width: 30%;
        height: 100%;
        user-select: none;
        background: var(--white);
        transition: 0.2s;
    }
    .sss-button{
        position: relative;
        display: flex;
        width: 100%;
        height: 100%;
        padding: 0.5rem;
    }
    .button-cover{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }
    .sss-text{
        width: 90%;
    }
    .sss-text-title{
        font-weight: 700;
        padding: 0 0.5rem 0 0.5rem;
    }
    .sss-text-button{
        padding: 0.5rem;
        font-size: 0.9rem;
    }
    .sss-icon{
        width: 10%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .sss-icon-inner{
        text-align: center;
        width: 20px;
        height: 20px;
    }
    .sss-icon img{
        max-width: 100%;
        transition: 0.2s;
    }
    .sss-option{
        position: absolute;
        top: 110%;
        left: 0;
        width: 100%;
        background: var(--white);
        display: none;
        -webkit-animation-name: animatesssoption;
        -webkit-animation-duration: 0.4s;
        animation-name: animatesssoption;
        animation-duration: 0.4s;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.37), 0 6px 20px 0 rgba(0, 0, 0, 0.37);
        z-index: 5;
    }
    @-webkit-keyframes animatesssoption {
        from {top:150%; opacity:0}
        to {top:110%; opacity:1}
    }
    @keyframes animatesssoption {
        from {top:150%; opacity:0}
        to {top:110%; opacity:1}
    }
    .float-active{
        display: block;
    }
    .sss-option-button{
        width: 100%;
        padding: 0.5rem 1rem 0.5rem 1rem;
    }
    .sss-option-button:hover{
        background: var(--smoke);
    }
    .si-search-input{
        width: 40%;
        height: 100%;
        display: flex;
        align-items: center;
        border-left: 1px solid var(--softgrey);
        padding: 1rem;
        background: var(--white);
        transition: 0.2s;
    }
    .si-search-input input{
        border: none;
        outline: none;
        width: 100%;
        height: 50px;
        color: var(--grey);
        font-size: 1.2rem;
    }
    .si-search-button{
        width: 30%;
        height: 100%;
        background: var(--primary);
        color: var(--white);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
        transition: 0.2s;
    }
    .section-body{
        padding: 3.75rem 10% 0 10%;
        transition: 0.2s;
    }
    .sb-inner{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    .sb-part{
        width: 33.33%;
        height: 270px;
        padding: 0.5rem;
        transition: 0.2s;
    }
    .sb-part-inner{
        position: relative;
        width: 100%;
        height: 100%;
        border-radius: 5px;
        overflow: hidden;
    }
    .spi-image{
        width: 100%;
        height: 100%;
        /* background: var(--grey); */
        animation: pulse-bg 1s infinite;
    }
    .spi-image img{
        width: 100%;
    }
    .spi-text{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 120px;
        background-image: linear-gradient(#0000009c, #000000);
        color: var(--white);
        padding: 0.5rem;
    }
    .spi-category{
        padding: 0.5rem 0 0.5rem 0;
        font-size: 0.75rem;
    }
    .spi-category span{
        padding: 0.25rem 1rem 0.25rem 1rem;
        background: var(--primary);
        color: var(--white);
        border-radius: 5px;
    }
    .spi-title{
        padding: 0.5rem 0 0 0;
    }
    .spi-title h2{
        font-size: 1rem;
        margin: 0;
        transition: 0.2s;
    }
    .section-more{
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 1rem 0 1rem 0;
    }
    .section-more button{
        font-family: poppins;
        font-weight: 500;
        font-size: 1rem;
        border: none;
        background: none;
        color: var(--grey);
        text-decoration: underline;
        cursor: pointer;
        user-select: none;
    }
    @media only screen and (max-width: 1500px){
        section{
            padding: 0 0 2.5rem 0;
        }
        .section-head{
            padding: 2.5rem 5% 150px 5%;
        }
        .si-box{
            left: 5%;
            right: 5%;
        }
        .section-body{
            padding: 3.75rem 4.5% 0 4.5%;
        }
    }
    @media only screen and (max-width: 1000px){
        .section-head{
            padding: 2.5rem 5% 225px 5%;
        }
        .si-search{
            height: auto;
            box-shadow: unset;
        }
        .si-search-select{
            width: 50%;
            height: 75px;
            border-top: 1px solid var(--softgrey);
            border-left: 1px solid var(--softgrey);
            border-bottom: 1px solid var(--softgrey);
        }
        .si-search-input{
            width: 50%;
            height: 75px;
            border-top: 1px solid var(--softgrey);
            border-right: 1px solid var(--softgrey);
            border-bottom: 1px solid var(--softgrey);
        }
        .si-search-button{
            width: 100%;
            height: 75px;
            margin-top: 1rem;
        }
        .sb-part{
            width: 50%;
        }
        /* .spi-title h2{
            font-size: 0.9rem;
        } */
    }
    @media only screen and (max-width: 750px){
        section{
            padding: 0 0 2.5rem 0;
        }
        .section-head{
            padding: 2.5rem 2.5% 300px 2.5%;
        }
        .si-box{
            left: 2.5%;
            right: 2.5%;
        }
        .si-search-select{
            width: 100%;
            border-right: 1px solid var(--softgrey);
        }
        .si-search-input{
            width: 100%;
            margin-top: 1rem;
            border: 1px solid var(--softgrey);
        }
        .si-search-button{
            width: 100%;
        }
        .section-body{
            padding: 3.75rem 1% 0 1%;
        }
        
        .spi-title h2{
            font-size: 0.9rem;
        }
    }
    @media only screen and (max-width: 600px){
        .sb-part{
            width: 100%;
        }
    }
</style>